<div class="d-md-flex align-items-center  p-2" style="background-color: #87858525;">
    <span class="d-flex align-items-center p-2 font-weight-bold font-14">
     {{(Padre ? 'Interventi' : 'RMA.title') | translate}}:&nbsp;
      <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0" *ngIf="permission.isOperativeRoles(['C']) || !environment.RmaAddOn.provaAcquisto  ">
    <button type="button" (click)="add()" class="btn btn-cyan rounded-pill p-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'RMA.add' | translate}}</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 HorizontalTable">
    <thead>
    <tr>
<!--      <th >Seriale</th>-->
<!--      <th scope="col">Modello</th>-->
      <th scope="col">{{(Padre ? 'Intervento' : 'RMA.title') | translate}}</th>
      <th scope="col">{{'RMA.status' | translate}}</th>
      <th scope="col" *ngIf="showLuogoIntervento()">{{'RMA.ritiro.title' | translate}}</th>
      <th scope="col">{{'RMA.dInizio' | translate}}</th>
      <th scope="col">{{'RMA.descDifetto' | translate}}</th>
      <th scope="col">{{'RMA.Actions' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let co of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
      <td>
        <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>

           <span class="badge badge-pill px-3   font-14" *ngIf="environment.RmaAddOn['fieldProgressivo']">
          {{ (co.padre ? 'Intervento' : 'RMA.title') | translate }}
             {{ ( " #"  + (co[environment.RmaAddOn['fieldProgressivo']]?  co[environment.RmaAddOn['fieldProgressivo']]?.toString() : "") + " " + (co?.nome ?? ''))}}
        </span>

        <span class="badge badge-pill px-3   font-14" *ngIf="!environment.RmaAddOn['fieldProgressivo']">
          {{'RMA.title' | translate}} #{{ ((co?.progressivo ?? co.id)?  (co?.progressivo ?? co.id)?.toString() : "") + " " + (co?.nome ?? '')}}
        </span>
          </span>
      </td>
      <td class="align-middle">
        <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;" [ngStyle]="{'background-color': co['color'] ?? '#000000'}"></span>
      </td>
<!--      <td class="align-middle">-->
<!--        <span class="text-dark font-medium font-16" >-->
<!--            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
<!--              <i-feather name="info" class="feather-sm"></i-feather>-->
<!--            </span>-->
<!--          {{co?.prodotto?.categorie && co.prodotto.categorie[0]? co.prodotto.categorie[0].categoria : "Non Associato"}}-->
<!--        </span>-->
<!--      </td>-->
      <td class="align-middle" *ngIf="!co.sedeObject && showLuogoIntervento()">
        {{ co?.ritiro?.nominativo ?? co.acquirente?.nominativo }} {{ co?.ritiro?.indirizzo ?? co.acquirente?.indirizzo }} {{ co?.ritiro?.citta ?? co.acquirente?.citta }} {{ co?.ritiro?.provincia ?? co.acquirente?.provincia }}
      </td>
      <td class="align-middle" *ngIf="co.sedeObject && showLuogoIntervento()">
        {{ co.ritiro ? co.ritiro.nominativo : co.acquirente?.nominativo }} {{  co.sedeObject?.indirizzo}} {{  co.sedeObject?.citta  }} {{ co.sedeObject?.provincia  }}
      </td>
      <td class="align-middle">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.data_inizio_prevista | date: "dd/MM/yyyy"}}
          </span>
      </td>
      <td class="align-middle ">
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.note}}
          </span>
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" (click)="edit(co)" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
<!--        <a *ngIf="co.enabled"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(co)'>-->
<!--          <i-feather name="trash-2" class="feather-sm"></i-feather>-->
<!--        </a>-->
<!--        <a *ngIf="!co.enabled" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(co)'>-->
<!--          <i-feather name="plus" class="feather-sm"></i-feather>-->
<!--        </a>-->
      </td>
    </tr>
    </tbody>
  </table>
  <table class="table bg-white table-hover align-middle mb-0 VerticalTable">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col" class="font-14">{{'RMA.Actions' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let co of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td>
          <div class="row">
            <div class="col-12">
              <span class="font-16" style="font-weight: bold !important;">{{(Padre ? 'Intervento' : 'RMA.title') | translate}}: &nbsp;</span>
                <span class="font-16 ">
                  <span class="badge badge-pill px-3   font-14" *ngIf="environment.RmaAddOn['fieldProgressivo']">
                  {{ (co.padre ? 'Intervento' : 'RMA.title') | translate }}
                    {{ ( " #"  + (co[environment.RmaAddOn['fieldProgressivo']]?  co[environment.RmaAddOn['fieldProgressivo']]?.toString() : "") + " " + (co?.nome ?? ''))}}
                </span>

                <span class="badge badge-pill px-3   font-14" *ngIf="!environment.RmaAddOn['fieldProgressivo']">
                  {{'RMA.title' | translate}} #{{ ((co?.progressivo ?? co.id)?  (co?.progressivo ?? co.id)?.toString() : "") + " " + (co?.nome ?? '')}}
                </span>
              </span>
            </div>
            <div class="col-12" *ngIf="showLuogoIntervento()">
              <span class="font-16" style="font-weight: bold !important;">{{'RMA.ritiro.title' | translate}}: &nbsp;</span>
              <span class="font-16 " *ngIf="!co.sedeObject">{{ co?.ritiro?.nominativo ?? co.acquirente?.nominativo }} {{ co?.ritiro?.indirizzo ?? co.acquirente?.indirizzo }} {{ co?.ritiro?.citta ?? co.acquirente?.citta }} {{ co?.ritiro?.provincia ?? co.acquirente?.provincia }}  </span>
              <span class="font-16 " *ngIf="co.sedeObject">{{ co.ritiro ? co.ritiro.nominativo : co.acquirente?.nominativo }} {{  co.sedeObject?.indirizzo}} {{  co.sedeObject?.citta  }} {{ co.sedeObject?.provincia  }}</span>
            </div>
            <div class="col-12">
              <span class="font-16" style="font-weight: bold !important;">{{'RMA.dInizio' | translate}}: &nbsp;</span>
              <span class="font-16 ">{{ co.data_inizio_prevista | date: "dd/MM/yyyy"}}</span>
            </div>
            <div class="col-12">
              <span class="font-16" style="font-weight: bold !important;">{{'RMA.descDifetto' | translate}}: &nbsp;</span>
              <span class="font-16 ">{{ co.note}}</span>
            </div>
            <div class="col-12 d-flex align-items-center">
              <span class="font-16" style="font-weight: bold !important;">{{'RMA.status' | translate}}: &nbsp;</span>
              <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;" [ngStyle]="{'background-color': co['color'] ?? '#000000'}"></span>
            </div>

          </div>

        </td>

        <td class="align-middle">
          <a href="javascript:void(0)" (click)="edit(co)" class="link font-16 text-info font-medium mr-2">
            <i class="fas fa-pencil-alt"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
                  [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
